import { render, staticRenderFns } from "./RulesStatistics.vue?vue&type=template&id=1c9469fe&scoped=true&"
import script from "./RulesStatistics.vue?vue&type=script&lang=js&"
export * from "./RulesStatistics.vue?vue&type=script&lang=js&"
import style0 from "./RulesStatistics.vue?vue&type=style&index=0&id=1c9469fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9469fe",
  null
  
)

export default component.exports